import { useMemo } from 'react';

import { useSession } from '~hooks/useSession';
import { botsApi } from '~services/api/bots';
import { userApi } from '~services/api/user';

export const useBotModels = () => {
	const { userId } = useSession();

	const { data } = botsApi.useGetBotModelsQuery({ userId });
	const { data: config } = userApi.useUserConfigQuery({ userId });

	const activeModel = useMemo(
		() => data?.find((model) => model.code === config?.activeModel),
		[data, config?.activeModel]
	);
	const activeModelTitle =
		activeModel && `${activeModel.name} ${activeModel.version}`;

	const premiumModel = useMemo(
		() =>
			data
				?.filter((model) => model.isPremium)
				.sort((a, b) => parseFloat(b.version) - parseFloat(a.version))?.[0],
		[data]
	);

	const freeModel = useMemo(
		() =>
			data
				?.filter((model) => !model.isPremium)
				.sort((a, b) => parseFloat(b.version) - parseFloat(a.version))?.[0],
		[data]
	);

	const activeNotTop =
		activeModel?.code !== premiumModel?.code &&
		activeModel?.code !== freeModel?.code;

	return {
		canSelectModel: config?.canSelectModel,
		activeModel,
		activeModelTitle,
		activeNotTop,
		premiumModel,
		freeModel,
		models: data || [],
	};
};
